import { ProFormColumnsType } from '@ant-design/pro-components';
import { createCurrencyFormItem } from '../createCurrencyFormItem';
import { createPercentageShareholdingFormItem } from './createPercentageShareholdingFormItem';
import { createNumberFormItem, createTextFormItem } from './createTextFormItem';

interface IncomeFormSchemaOptions {
  includePercentageShareholding?: boolean;
}

export const companyDirectorFormSchema = (options?: IncomeFormSchemaOptions): ProFormColumnsType[] => [
  {
    valueType: 'group',
    columns: [
      ...['companyName', 'occupation'].map(item => createTextFormItem(item, 'member.income')),
      ...['timeTrading'].map(item => createNumberFormItem(item, 'member.income', 1)),
      ...(options?.includePercentageShareholding ? [createPercentageShareholdingFormItem(true)] : []),
      ...['salaryMostRecentYear', 'dividendsMostRecentYear', 'salaryPriorYear', 'dividendsPriorYear'].map(item =>
        createCurrencyFormItem(null, item, 'member.income', undefined, true),
      ),
    ],
  },
];
